export const MAX_SHIFT_SHORT_NAME_LENGTH = 5;
export const DAY_VIEW_COLUMN_COUNT = 5;
